import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    productId: String,
    userId: String,
    confirmMessage: String
  }

  connect() {
    this.isInApp = typeof window.flutter_inappwebview !== "undefined"
  }

  async purchase() {
    if (!this.isInApp) {
      console.warn("apple-iap-payment: not running inside Flutter WebView")
      return
    }

    if (!confirm(this.confirmMessageValue)) return

    try {
      this.element.disabled = true

      const result = await window.flutter_inappwebview.callHandler("purchasePlan", {
        productId: this.productIdValue,
        userId: this.userIdValue
      })

      console.log("purchasePlan result:", result)
    } catch (error) {
      console.error("purchasePlan error:", error)
      this.element.disabled = false
    }
  }
}
